function nousTrouver() {
  let cols = 0;
  let type = '';
  let maxHeight = 0;

  if(Foundation.MediaQuery.current == 'small') {
    type = 'small';
  }
  if(Foundation.MediaQuery.current == 'medium') {
    cols = 2;
    type = 'medium';
  }
  if(Foundation.MediaQuery.current !== 'medium' && Foundation.MediaQuery.current !== 'small') {
    cols = 3;
    type = 'large';
  }

  if (type != 'small') {
    // Calcul du nombre de rows total
    const countriesLength = $('.wrap-countries .columns').length;
    const row = countriesLength / cols;

    // Pour chaque row, on va calculer l'item qui a la taille max et l'attribuer à tous les items de la row
    for (let i = 1; i <= row; i++) {
      maxHeight = 0;
      const uls = $(`.wrap-countries .columns[data-row-${type}='${i}']`);
      jQuery.each(uls, function(index, item) {
        const el = $(item).find('.countries__item__wrap-labels');
        const colHeight = el.outerHeight();

        if (colHeight > maxHeight) {
          maxHeight = colHeight;
        }
      });

      // appliquer la maxHeight sur toutes les cols qui ont la meme row 
      uls.find('.countries__item__wrap-labels').css('height', maxHeight+"px");
    }
  }
}

module.exports = function () {
  window.addEventListener('load ready resize', nousTrouver);
  nousTrouver();
};
